import type { Quiz } from "./_schema";
import { quizBeforeTrtQuiz } from "./quiz-before-trt";
import { cortisolQuiz } from "./cortisol";
import { cortisolQuizAlQuiz } from "./cortisol-quiz-al";
import { cortisolQuizGlQuiz } from "./cortisol-quiz-gl";
import { cortisolQuizXQuiz } from "./cortisol-quiz-x";
import { igniteQuiz } from "./ignite";
import { quizV6GatedQuiz } from "./quiz-v6-gated";
import { quizGlpQuiz } from "./quiz-glp";
import { quizV6GlQuiz } from "./quiz-v6-gl";
import { quizV6AlQuiz } from "./quiz-v6-al";
import { quizV6XQuiz } from "./quiz-v6-x";
import { quizV6EsQuiz } from "./quiz-v6-es";
import { quizV7Quiz } from "./quiz-v7";
import { tCalcQuiz } from "./t-calc";
import { quizTrtSwitchQuiz } from "./quiz-trt-switch";
import { quizWeightlossQuiz } from "./quiz-weightloss";
import { quizWeightlossV2Quiz } from "./quiz-weightloss-v2";
import { quizEnergyQuiz } from "./quiz-energy";
import { quizSleepQuiz } from "./quiz-sleep";
import { quizBeerQuiz } from "./quiz-beer";
import { quizLibidoQuiz } from "./quiz-libido";

// `free-t` is intentionally NOT registered as a public slug. The free-t quiz
// implementation in `quizzes/free-t.ts` is the canonical Vermeulen calculator
// that `t-calc` inherits from (`tCalcQuiz.compute = freeTQuiz.compute`, etc.),
// but it has no live Shopify page and is not loadable via `?quiz=free-t`. If
// a future calculator wants to expose it as its own slug, add the entry back
// here and to `api/schemas/submission.py` (QUIZ_SLUGS + CALCULATOR_SLUGS).
export const quizRegistry: Record<string, Quiz> = {
  [igniteQuiz.slug]: igniteQuiz,
  [quizV6GatedQuiz.slug]: quizV6GatedQuiz,
  [quizV6GlQuiz.slug]: quizV6GlQuiz,
  [quizV6AlQuiz.slug]: quizV6AlQuiz,
  [quizV6XQuiz.slug]: quizV6XQuiz,
  [quizV6EsQuiz.slug]: quizV6EsQuiz,
  [quizV7Quiz.slug]: quizV7Quiz,
  [tCalcQuiz.slug]: tCalcQuiz,
  [cortisolQuiz.slug]: cortisolQuiz,
  [cortisolQuizAlQuiz.slug]: cortisolQuizAlQuiz,
  [cortisolQuizGlQuiz.slug]: cortisolQuizGlQuiz,
  [cortisolQuizXQuiz.slug]: cortisolQuizXQuiz,
  [quizGlpQuiz.slug]: quizGlpQuiz,
  [quizBeforeTrtQuiz.slug]: quizBeforeTrtQuiz,
  [quizTrtSwitchQuiz.slug]: quizTrtSwitchQuiz,
  [quizWeightlossQuiz.slug]: quizWeightlossQuiz,
  [quizWeightlossV2Quiz.slug]: quizWeightlossV2Quiz,
  [quizEnergyQuiz.slug]: quizEnergyQuiz,
  [quizSleepQuiz.slug]: quizSleepQuiz,
  [quizBeerQuiz.slug]: quizBeerQuiz,
  [quizLibidoQuiz.slug]: quizLibidoQuiz,
};
